import { Box, Grid, Stack } from "@mui/material";
import CustomTextField from "../../../components/Form/CustomTextField";
import React from "react";
import FormEditors from "../../Forms/FormEditors";

export default function AdvertisementInfo({ formObj, handleFormChange, error }) {

    return (
        <React.Fragment>
            <Box mt={2}>
                <div className="text-semibold mb-2">Listing Title</div>
                <CustomTextField
                    title={'Listing Title'}
                    placeholder={'Listing Title'}
                    values={formObj?.title || ''}
                    onChange={(e) => handleFormChange('title', e)}
                    error={error?.title}
                />
            </Box>

            <Box mt={4}>
                <div className="text-semibold mb-2">Listing Description</div>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <FormEditors
                            value={formObj?.description || ''}
                            setValue={(e) => handleFormChange('description', e)}
                            error={error?.description}
                        />
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>

    )
}